import React, { useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react'
import { isEmpty } from 'lodash'
import { convertDuration, raiseToast } from 'src/views/utils/helper'
import moment from 'moment'
import TrashIcon from '../../../assets/trash-icon-black.svg'
import DownloadIcon from '../../../assets/recording-download-icon.svg'
import RecordingCard from './recordingCard'

const RecordingsModal = ({ data, onClose, onDelete, onDownload }) => {
  const [recordingData, setRecordingData] = useState([])

  useEffect(() => {
    if (data) {
      setRecordingData(JSON.parse(JSON.stringify(data)))
    }
  }, [data])
  return (
    <CModal
      size="xl"
      scrollable
      visible={true}
      alignment="center"
      className="recording-modal border-0"
    >
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0">
          Recorded Files
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <p
          style={{ fontSize: '14px' }}
        >{`Following are the Recorded files of 'Test Live' Live Stream. The video files are also available in the Asset Manager with same name as mentioned in the 'File name'. Click on 'Download' to save the recorded file in your local drive.`}</p>
        <div
          style={{ height: '40vh', overflowX: 'hidden' }}
          className="custom-scrollbar-vertical mt-4"
        >
          <div
            className="d-flex justify-content-center align-items-center w-100 bg-black text-white"
            style={{
              fontSize: 'max(0.63vw,10px)',
              // gap: '0 2.2%',
              paddingTop: '2px',
              paddingBottom: '2px ',
              top: '0',
              position: 'sticky',
              zIndex: '1',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
            }}
          >
            <div style={{ width: '10%' }} className="text-center mx-2">
              Thumbnail
            </div>
            <div style={{ width: '90%' }} className="d-flex align-items-center">
              <div style={{ width: '25%' }}>Session ID</div>
              <div style={{ width: '16%' }}>Start</div>
              <div style={{ width: '16%' }}>End</div>
              <div style={{ width: '10%' }}>Duration</div>
              <div style={{ width: '28%' }}>File Name</div>
              <div style={{ width: '5%' }} />
            </div>
          </div>
          <div>
            <div
              className="d-flex flex-wrap"
              style={{
                gap: '1vw 0',
                padding: '10px 2px 10px 2px',
              }}
            >
              {!isEmpty(recordingData) ? (
                recordingData
                  .sort((first, second) => {
                    return second.start - first.start
                  })
                  .map((info, index) => {
                    let tempDuration = convertDuration(
                      moment.unix(info.end).diff(moment.unix(info.start), 'second'),
                    )

                    const disabled = !info.recording || !info.end
                    let fileName = '-'
                    if (!disabled) {
                      let words = info?.s3_key.split('/')
                      fileName = words[words.length - 1]
                    }
                    return (
                      <RecordingCard
                        cardImage={''}
                        disableStatus={true}
                        textData={[
                          {
                            name: info?.session_id,
                            styles: { width: '25%' },
                          },
                          {
                            name: moment.unix(info.start).format('hh:mm A, DD-MM-YYYY'),
                            styles: { width: '16%' },
                          },
                          {
                            name: info.end
                              ? moment.unix(info.end).format('hh:mm A, DD-MM-YYYY')
                              : '-',
                            styles: { width: '16%' },
                          },
                          {
                            name: info.end && tempDuration !== 'N/A' ? tempDuration : '-',
                            styles: { width: '10%' },
                          },
                          {
                            name: <div className="line-clamp-1">{fileName}</div>,
                            styles: { width: '28%' },
                          },
                        ]}
                        key={index}
                        actionButtonOptions={[
                          {
                            name: <div style={{ opacity: `${disabled ? 50 : ''}%` }}>Download</div>,
                            btnFunction: !disabled
                              ? () => onDownload(info)
                              : () => {
                                  raiseToast('error', 'Recording not available!')
                                },
                            logo: (
                              <div
                                className="flex mr-1"
                                style={{ opacity: `${disabled ? 50 : ''}%` }}
                              >
                                <img style={{ width: '10px' }} src={DownloadIcon} />
                              </div>
                            ),
                          },
                          {
                            name: <div style={{ opacity: `${disabled ? 50 : ''}%` }}>Delete</div>,
                            btnFunction: !disabled
                              ? () => onDelete(info)
                              : () => {
                                  raiseToast('error', 'Recording not available!')
                                },
                            logo: (
                              <div
                                className="flex mr-1"
                                style={{ opacity: `${disabled ? 50 : ''}%` }}
                              >
                                <img style={{ width: '10px' }} src={TrashIcon} />
                              </div>
                            ),
                          },
                        ]}
                        actionButtonWidth="5%"
                      />
                    )
                  })
              ) : (
                <p className="text-center mb-0 w-100">{`No Recordings available`}</p>
              )}
            </div>
          </div>
        </div>
      </CModalBody>
      <CModalFooter className="px-5 border-0">
        <CButton
          style={{ border: '1px solid black', fontSize: '.9vw' }}
          className=" bg-black rounded-1 btn-focus-none px-4"
          onClick={onClose}
        >
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default RecordingsModal
